function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { attach, nodeArray } from 'meteora';
var Breakpoint = /*#__PURE__*/function () {
  function Breakpoint(el) {
    var _this = this;
    _classCallCheck(this, Breakpoint);
    this.container = el;
    this.breakpoint = {};
    this.children = this.getChildren();
    if (this.container.getAttribute('data-breakpoint') !== '') {
      setTimeout(function () {
        return _this.init();
      }, 5);
    } else {
      console.warn('Please add a classname to the data-breakpoint attribute');
    }
  }
  _createClass(Breakpoint, [{
    key: "toggleClass",
    value: function toggleClass() {
      for (var key in this.breakpoint) {
        this.container.offsetWidth >= this.breakpoint[key] ? this.container.classList.remove("js-breakpoint-".concat(key)) : this.container.classList.add("js-breakpoint-".concat(key));
      }
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;
      var childHolder = {};
      var allChildren = nodeArray(this.container.querySelectorAll('[data-breakpoint-watch]'));
      var targetArray = this.container.getAttribute('data-breakpoint').split(',');
      targetArray.forEach(function (id) {
        _this2.breakpoint[id] = 250;
        childHolder[id] = [];
        allChildren.forEach(function (child) {
          if (_this2.testChild(child, id)) childHolder[id].push(child);
        });
      });
      return childHolder;
    }
  }, {
    key: "testChild",
    value: function testChild(child, id) {
      return child.getAttribute('data-breakpoint-watch').indexOf(id) > -1;
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      var _loop = function _loop(key) {
        nodeArray(_this3.children[key]).forEach(function (child) {
          _this3.breakpoint[key] += child.offsetWidth;
        });
      };
      // Create the breakpoint
      for (var key in this.children) {
        _loop(key);
      }
      this.container.classList.add('js-breakpoint');

      // Init functions
      attach(window, 'resize', function () {
        return _this3.toggleClass();
      }, 100);
    }
  }]);
  return Breakpoint;
}();
export default Breakpoint;